// extracted by mini-css-extract-plugin
export default {"wrapperPadding":"MonitorDeviceDashBoard_wrapperPadding__4Jf0w"};